import { Lang } from '@common/typescript/objects/Lang';

export const LanguageNames = {
	[Lang.En]: 'English',
	[Lang.Es]: 'Spanish',
};
